const Strings = {
  TEST_VERSION: {
    SE:
      'Detta är en testversion av HomePal. Klicka på "Se pris" för att kontakta oss.',
    EN:
      'This is a test version of HomePal. Click on "See price" to register your housing association.'
  },
  TEST_VERSION_SHORT: {
    SE: 'Klicka på KOM IGÅNG för att registrera din förening.',
    EN: 'Click on GET STARTED to register your housing association.'
  },
  SEE_PRICE: {
    SE: 'Se pris',
    EN: 'See price'
  },
  CONTACT_US: {
    SE: 'Kontakta oss',
    EN: 'Contact us'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/OfflineModeHeader/strings.js